import {
    FETCH_REX,
    FETCH_REXS_LIST,
    FETCH_REXS,
    CREATE_REX,
    UPDATE_REX,
    UPDATE_REX_PICTURE,
    DELETE_REX,
    SET_INITIAL_STATE_REX,
    EXPORT_REX,
    REX_ERROR
  } from '../actions/types';
  
  const INITIAL_STATE = {
    rex: {},
    rexExtract: "",
    rexs: {},
    list: {},
    message: '',
    error: ''
  };
  
  export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
      case FETCH_REXS:
        return { ...state,
          rexs: action.payload.rexs,
          rex: {},
          message: '',
          error: ''
        };
      case FETCH_REX:
        return { ...state,
          rex: action.payload.rex,
          rexExtract:action.payload.rexExtract,
          message: action.payload.message ? action.payload.message :'' ,
          error: ''
        };
      case FETCH_REXS_LIST:
        return { ...state,
          list: action.payload.list,
          message: '',
          error: ''
        };
      case CREATE_REX:
        return { ...state,
          rex: action.payload.rex,
          message: action.payload.message,
          error: ''
        };
      case UPDATE_REX:
        return { ...state,
          rex: action.payload.rex,
          message: action.payload.message,
          error: ''
        };
      case DELETE_REX:
        return { ...state,
          rexs: {},
          message: action.payload.message,
          error: ''
        };
      case REX_ERROR:
        return { ...state,
          error: action.payload
        };
      case UPDATE_REX_PICTURE:
        let rex = Object.assign({}, state.rex);
        rex.picture64 = action.payload.picture64
        return { ...state,
          rex: rex,
          message: action.payload.message,
          error: ''
        };
      case EXPORT_REX:
          return { ...state, export: action.payload, message: '', error: '' };
      case SET_INITIAL_STATE_REX:
        return {
          rex: {},
          rexs: {},
          list: {},
          message: '',
          error: ''
        };
      default:
        return { ...state
        }
    }
  
    //return state;
  }
  